import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { ActionLogEntry } from '../types';
import type { PaginatedResponse } from '@shared/types';
import type { ActivityParams } from '@api/queryKeys';

export function useActivity(params: ActivityParams) {
  return useQuery({
    queryKey: queryKeys.activity(params),
    queryFn: () => {
      const qp: Record<string, string> = {
        page: String((params.page ?? 0) + 1),
        size: String(params.size ?? 50),
      };
      if (params.module) qp.module = params.module;
      if (params.status) qp.status = params.status;
      if (params.search) qp.search = params.search;
      if (params.correlationId) qp.correlationId = params.correlationId;
      if (params.operationId) qp.operationId = params.operationId;
      if (params.from) qp.from = params.from;
      if (params.to) qp.to = params.to;
      return apiClient.get<PaginatedResponse<ActionLogEntry>>('/activity', qp);
    },
    placeholderData: keepPreviousData,
  });
}
